/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Children_DescriptionInputs */

const fr_guardian_children_description = /** @type {(inputs: Guardian_Children_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profils enfants gérés par ce parent pour les inscriptions aux cours Kids.`)
};

/**

* @param {Guardian_Children_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_children_description = /** @type {((inputs?: Guardian_Children_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Children_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_children_description(inputs)
});